import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as THREE from 'three';
import View from "../View";
import CameraUtils from "../../Utils/CameraUtils";
import PlanarControls from "../../Controls/PlanarControls";
import PlanarLayer from "./Planar/PlanarLayer";

var PlanarView = /*#__PURE__*/function (_View) {
  _inherits(PlanarView, _View);

  var _super = _createSuper(PlanarView);

  /**
   * @constructor
   * @extends View
   *
   * @example <caption><b>Enable WebGl 1.0 instead of WebGl 2.0.</b></caption>
   * var viewerDiv = document.getElementById('viewerDiv');
   * const extent = new Extent('EPSG:3946', 1837816.94334, 1847692.32501, 5170036.4587, 5178412.82698);
   * var view = new itowns.PlanarView(viewerDiv, extent, {  renderer: { isWebGL2: false } });
   *
   * @example <caption><b>Instance with placement on the ground.</b></caption>
   * var viewerDiv = document.getElementById('viewerDiv');
   * const extent = new Extent('EPSG:3946', 1837816.94334, 1847692.32501, 5170036.4587, 5178412.82698);
   * var view = new itowns.PlanarView(viewerDiv, extent, { placement: { heading: -49.6, range: 6200, tilt: 17 } });
   *
   * @param {HTMLDivElement} viewerDiv - Where to attach the view and display it
   * in the DOM.
   * @param {Extent} extent - The ground extent.
   * @param {object=} options - See options of {@link View}.
   * @param {boolean} [options.noControls=false] - If true, no controls are associated to the view.
   * @param {object=} [options.controls] - options for the {@link PlanarControls} associated to the view, if
   * `options.noControls` is false.
   * @param {CameraUtils~CameraTransformOptions|Extent} [options.placement] - The
   * {@link CameraUtils~CameraTransformOptions} to apply to view's camera or the extent it must display at
   * initialization. By default, camera will display the view's extent (given in `extent` parameter).
   */
  function PlanarView(viewerDiv, extent) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, PlanarView);

    THREE.Object3D.DEFAULT_UP.set(0, 0, 1); // Setup View

    _this = _super.call(this, extent.crs, viewerDiv, options);
    _this.isPlanarView = true; // Configure camera

    var dim = extent.planarDimensions();
    var max = Math.max(dim.x, dim.y);
    var camera3D = _this.camera.camera3D;
    camera3D.near = 0.1;
    camera3D.far = camera3D.isOrthographicCamera ? 2000 : 2 * max;
    camera3D.updateProjectionMatrix();
    var tileLayer = new PlanarLayer('planar', extent, options.object3d, options);
    _this.mainLoop.gfxEngine.label2dRenderer.infoTileLayer = tileLayer.info;

    _this.addLayer(tileLayer); // Configure camera


    var placement = options.placement || {};

    if (!placement.isExtent) {
      placement.coord = placement.coord || extent.center();
      placement.tilt = placement.tilt || 90;
      placement.heading = placement.heading || 0;
      placement.range = placement.range || max;
    }

    CameraUtils.transformCameraToLookAtTarget(_assertThisInitialized(_this), camera3D, placement);

    if (!options.noControls) {
      _this.controls = new PlanarControls(_assertThisInitialized(_this), options.controls);
    }

    _this.tileLayer = tileLayer;
    return _this;
  }

  _createClass(PlanarView, [{
    key: "addLayer",
    value: function addLayer(layer) {
      return _get(_getPrototypeOf(PlanarView.prototype), "addLayer", this).call(this, layer, this.tileLayer);
    }
  }]);

  return PlanarView;
}(View);

export default PlanarView;